import {Component} from '@angular/core';

@Component({
  template: `<h1 class="text-center text-success">Success, redirecting to page, close manually if not closed automatically!</h1>`
})

export class RedirectionSuccessComponent {

}
